
export default {
  areaCode_China: 'China',
  areaCode_Macau: 'Macau',
  areaCode_Taiwan: 'Taiwan',
  areaCode_HongKong: 'Hongkong',
  areaCode_Albania: 'Albania',
  areaCode_Algeria: 'Algeria',
  areaCode_Afghanistan: 'Afghanistan',
  areaCode_Argentina: 'Argentina',
  areaCode_UnitedArabEmirates: 'United Arab Emirates',
  areaCode_Aruba: 'Aruba',
  areaCode_Oman: 'Oman',
  areaCode_Azerbaijan: 'Azerbaijan',
  areaCode_Egypt: 'Egypt',
  areaCode_Ethiopia: 'Ethiopia',
  areaCode_Ireland: 'Ireland',
  areaCode_Estonia: 'Estonia',
  areaCode_Andorra: 'Andorra',
  areaCode_Angola: 'Angola',
  areaCode_Anguilla: 'Anguilla',
  areaCode_AntiguaAndBarbuda: 'Antigua and Barbuda',
  areaCode_Austria: 'Austria',
  areaCode_Australia: 'Australia',
  areaCode_Barbados: 'Barbados',
  areaCode_PapuaNewGuinea: 'Papua New Guinea',
  areaCode_Bahamas: 'Bahamas',
  areaCode_Pakistan: 'Pakistan',
  areaCode_Paraguay: 'Paraguay',
  areaCode_Palestine: 'Palestine',
  areaCode_Bahrain: 'Bahrain',
  areaCode_Panama: 'Panama',
  areaCode_Brazil: 'Brazil',
  areaCode_Belarus: 'Belarus',
  areaCode_Bermuda: 'Republic of Belarus',
  areaCode_Bulgaria: 'Bulgaria',
  areaCode_Benin: 'Benin',
  areaCode_Belgium: 'Belgium',
  areaCode_Iceland: 'Iceland',
  areaCode_PuertoRico: 'Puerto Rico',
  areaCode_Poland: 'Poland',
  areaCode_BosniaandHerzegovina: 'Bosnia and Herzegovina',
  areaCode_Bolivia: 'Bolivia',
  areaCode_Belize: 'Belize',
  areaCode_Botswana: 'Botswana',
  areaCode_Bhutan: 'Bhutan',
  areaCode_BurkinaFaso: 'Burkina Faso',
  areaCode_Burundi: 'Burundi',
  areaCode_EquatorialGuinea: 'Equatorial Guinea',
  areaCode_Denmark: 'Denmark',
  areaCode_Germany: 'Germany',
  areaCode_TimorLeste: 'Timor-Leste',
  areaCode_Togo: 'Togo',
  areaCode_Dominica: 'Dominica',
  areaCode_DominicanRepublic: 'Dominican Republic',
  areaCode_Russia: 'Russia',
  areaCode_Ecuador: 'Ecuador',
  areaCode_Eritrea: 'Eritrea',
  areaCode_France: 'France',
  areaCode_FaroeIslands: 'Faroe Islands',
  areaCode_FrenchPolynesia: 'French Polynesia',
  areaCode_FrenchGuiana: 'French Guiana',
  areaCode_Philippines: 'Philippines',
  areaCode_Fiji: 'Fiji',
  areaCode_Finland: 'Finland',
  areaCode_Gambia: 'Gambia',
  areaCode_RepublicOfTheCongo: 'Republic of Congo',
  areaCode_DemocraticRepublicof: 'Democratic Republic of Congo',
  areaCode_Colombia: 'Colombia',
  areaCode_CostaRica: 'Costa Rica',
  areaCode_Grenada: 'Grenada',
  areaCode_Greenland: 'Greenland',
  areaCode_Georgia: 'Georgia',
  areaCode_Cuba: 'Cuba',
  areaCode_Guadeloupe: 'Guadeloupe',
  areaCode_Guatemala: 'Guatemala',
  areaCode_Guam: 'Guam',
  areaCode_Guyana: 'Guyana',
  areaCode_Kazakhstan: 'Kazakhstan',
  areaCode_Haiti: 'Haiti',
  areaCode_SouthKorea: 'South Korea',
  areaCode_Netherlands: 'Netherlands',
  areaCode_Montenegro: 'Republic of Montenegro',
  areaCode_Honduras: 'Honduras',
  areaCode_Djibouti: 'Djibouti',
  areaCode_Kiribati: 'Kiribati',
  areaCode_Kyrgyzstan: 'Kyrgyzstan',
  areaCode_Guinea: 'Guinea',
  areaCode_GuineaBissau: 'The Republic of Guinea',
  areaCode_Canada: 'Canada',
  areaCode_Ghana: 'Ghana',
  areaCode_Gabon: 'Gabon',
  areaCode_Cambodia: 'Cambodia',
  areaCode_Czech: 'Czech Republic',
  areaCode_Zimbabwe: 'Zimbabwe',
  areaCode_Cameroon: 'Cameroon',
  areaCode_Qatar: 'Qatar',
  areaCode_CaymanIslands: 'Cayman Islands',
  areaCode_CapeVerde: 'Cape',
  areaCode_Comoros: 'Comoros',
  areaCode_Kuwait: 'Kuwait',
  areaCode_Croatia: 'Croatia',
  areaCode_Kenya: 'Kenya',
  areaCode_CookIslands: 'Cook Islands',
  areaCode_Curacao: 'Curacao',
  areaCode_Latvia: 'Latvia',
  areaCode_Lesotho: 'Lesotho',
  areaCode_Laos: 'Laos',
  areaCode_Lebanon: 'Lebanon',
  areaCode_Lithuania: 'Lithuania',
  areaCode_Liberia: 'Liberia',
  areaCode_Libya: 'Libya',
  areaCode_Liechtenstein: 'Liechtenstein',
  RéunionIsland: 'Reunion',
  areaCode_Luxembourg: 'Luxembourg',
  areaCode_Rwanda: 'Rwanda',
  areaCode_Romania: 'Romania',
  areaCode_Madagascar: 'Madagascar',
  areaCode_Maldives: 'Maldives',
  areaCode_Malta: 'Malta',
  areaCode_Malawi: 'Malawi',
  areaCode_Malaysia: 'Malaysia',
  areaCode_Mali: 'Mali',
  areaCode_Macedonia: 'Macedonia',
  areaCode_Martinique: 'Martinique',
  areaCode_Mayotte: 'Mayotte Island',
  areaCode_Mauritius: 'Mauritius',
  areaCode_Mauritania: 'Mauritania',
  areaCode_UnitedStates: 'United States',
  areaCode_AmericanSamoa: 'Samoa',
  areaCode_VirginIslandsUS: 'United States Virgin Islands',
  areaCode_Mongolia: 'Mongolia',
  areaCode_Montserrat: 'Montserrat',
  areaCode_Bangladesh: 'Bangladesh',
  areaCode_Peru: 'Peru',
  areaCode_Myanmar: 'Myanmar',
  areaCode_Moldova: 'Moldova',
  areaCode_Morocco: 'Morocco',
  areaCode_Monaco: 'Monaco',
  areaCode_Mozambique: 'Mozambique',
  areaCode_Mexico: 'Mexico',
  areaCode_Namibia: 'Namibia',
  areaCode_SouthAfrica: 'South Africa',
  areaCode_Nepal: 'Nepal',
  areaCode_Nicaragua: 'Nicaragua',
  areaCode_Niger: 'Niger',
  areaCode_Nigeria: 'Nigeria',
  areaCode_Norway: 'Norway',
  areaCode_Palau: 'Palau',
  areaCode_Portugal: 'Portugal',
  areaCode_Japan: 'Japan',
  areaCode_Sweden: 'Sweden',
  areaCode_Switzerland: 'Switzerland',
  areaCode_ElSalvador: 'El Salvador',
  areaCode_Samoa: 'Samoa',
  areaCode_Serbia: 'Serbia',
  areaCode_SierraLeone: 'Sierra Leone',
  areaCode_Senegal: 'Senegal',
  areaCode_Cyprus: 'Cyprus',
  areaCode_Seychelles: 'Seychelles',
  areaCode_SaudiArabia: 'Saudi Arabia',
  areaCode_SaintPierreandMiquel: 'Saint-Pierre-et-Miquelon',
  areaCode_SaoTomeandPrincipe: 'Sao Tome and Principe',
  areaCode_SaintKittsandNevis: 'The Federation of Saint Kitts and Nevis',
  areaCode_SaintLucia: 'Saint Lucia',
  areaCode_SintMaartenDutchPar: 'Saint Martin (Dutch part)',
  areaCode_SanMarino: 'San Marino',
  areaCode_SaintVincentandTheG: 'Saint Vincent and the Grenadines',
  areaCode_SriLanka: 'Sri Lanka',
  areaCode_Slovakia: 'Slovakia',
  areaCode_Slovenia: 'Slovenia',
  areaCode_Swaziland: 'Swaziland',
  areaCode_Sudan: 'Sudan',
  areaCode_Suriname: 'Suriname',
  areaCode_SolomonIslands: 'Solomon Islands',
  areaCode_Somalia: 'Somalia',
  areaCode_Tajikistan: 'Tajikistan',
  areaCode_Thailand: 'Thailand',
  areaCode_Tanzania: 'Tanzania',
  areaCode_Tonga: 'Tonga',
  areaCode_TurksandCaicosIsland: 'Turks and Caicos Islands',
  areaCode_TrinidadandTobago: 'Trinidad and Tobago',
  areaCode_Tunisia: 'Tunisia',
  areaCode_Turkey: 'Turkey',
  areaCode_Turkmenistan: 'Turkmenistan',
  areaCode_Vanuatu: 'Vanuatu',
  areaCode_Venezuela: 'Venezuela',
  areaCode_Brunei: 'Brunei Darussalam',
  areaCode_Uganda: 'Uganda',
  areaCode_Ukraine: 'Ukraine',
  areaCode_Uruguay: 'Uruguay',
  areaCode_Uzbekistan: 'Uzbekistan',
  areaCode_Spain: 'Spain',
  areaCode_Greece: 'Greece',
  areaCode_IvoryCoast: 'Ivory Coast',
  areaCode_Singapore: 'Singapore',
  areaCode_NewCaledonia: 'New Caledonia',
  areaCode_NewZealand: 'New Zealand',
  areaCode_Hungary: 'Hungary',
  areaCode_Syria: 'Syria',
  areaCode_Jamaica: 'Jamaica',
  areaCode_Armenia: 'Armenia',
  areaCode_Yemen: 'Yemen',
  areaCode_Iraq: 'Iraq',
  areaCode_Iran: 'Iran',
  areaCode_Israel: 'Israel',
  areaCode_Italy: 'Italy',
  areaCode_India: 'India',
  areaCode_Indonesia: 'Indonesia',
  areaCode_UnitedKingdom: 'United Kingdom',
  areaCode_VirginIslandsBritish: 'British Virgin Islands',
  areaCode_Jordan: 'Jordan',
  areaCode_Vietnam: 'Vietnam',
  areaCode_Zambia: 'Zambia',
  areaCode_Chad: 'Chad',
  areaCode_Gibraltar: 'Gibraltar',
  areaCode_Chile: 'Chile',
  areaCode_CentralAfricanRepubli: 'Central African Republic',
}
